var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStopCanceled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F6F8FB",
    fillRule: "nonzero",
    cx: 13,
    cy: 13,
    r: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.3223,
    y1: 5.09188,
    x2: 4.32234,
    y2: 22.0919,
    id: "Path",
    stroke: "#A6B6C5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#A6B6C5",
    strokeWidth: 2,
    cx: 13,
    cy: 13,
    r: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopCanceled);
export default __webpack_public_path__ + "static/media/stop-canceled.853618e64e369b69276ef5851c3ab32e.svg";
export { ForwardRef as ReactComponent };